import { useEffect, useState } from 'react';
import posthog from 'posthog-js';

export function useFeatureFlags(flagsMap, fallbackValue = false) {
  const [flags, setFlags] = useState(() => {
    const initial = {};
    for (const key in flagsMap) {
      initial[key] = fallbackValue;
    }
    return initial;
  });

  useEffect(() => {
    const updateFlags = () => {
      const updated = {};
      for (const key in flagsMap) {
        const flagKey = flagsMap[key];
        updated[key] = posthog.isFeatureEnabled(flagKey);
      }
      setFlags(updated);
    };

    updateFlags();

    posthog.onFeatureFlags(updateFlags);

    if (typeof posthog.offFeatureFlags === 'function') {
      return () => {
        posthog.offFeatureFlags(updateFlags);
      };
    }

    return () => {};
  }, [JSON.stringify(flagsMap), fallbackValue]);

  return flags;
}
